module.exports = __webpack_public_path__ + "img/背景浮云.41ba8c15.png";